import {TabContent} from '../TabContent'

export const BankRating = ({data}) => {
  return <TabContent tab={'BankRating'} data={data} />
}
